<template>
<div>
    <a-modal
      :title="title"
      :visible="visible"
     :confirm-loading="confirmLoading"
     width="560px"
      @cancel="handleCancel"
    >
     <a-input-group compact style="margin-bottom:10px;">
      <a-select default-value="zname" @change="onSearchChange">
        <a-select-option value="zname">
          {{name_title}}
        </a-select-option>
        <a-select-option value="zcode">
          {{code_title}}
        </a-select-option>
      </a-select>
      <a-input-search style="width: 50%" default-value=""  @search="onSearch" />
    </a-input-group>

     <a-table
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :columns="columns"
      :data-source="list"
      rowKey="s_code"
      :pagination="false"
    />

    <br />

    <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange" style="float:right;" show-less-items show-quick-jumper />
    <br />

     <template slot="footer">
         <div style="float:left;font-weight:bolder;color:green;">已选：{{selectedRowKeys.length}}</div>
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
  
</template>
<script>
const columns = [
    {title: '',
        dataIndex: 's_code',
        align: 'center',
        width:80
    }, {
        title: '',
        dataIndex: 's_name',
        align: 'center',
        width:80
    }
];

export default {
    data() {
        return {
            confirmLoading: false,
            columns:columns,
            type:1,
            selectedRowKeys: [], // Check here to configure the default column
            loading: false,
            title:'',
            visible:false,
            list:[],
            searchKey:'zname',
            searchVal:'',
            usercode:'',
            name_title:'',
            code_title:'',
            pagination:{
                total:0,
                pageSize:10,
                current:1,
            },
            originData:[],
            savedPages:[],
        };
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
    },
    props:{
 
    },
    methods: {
        handlePageChange(params_page){
            let c_type = this.type
            if(c_type == 1){
                this.onModalInit(this.usercode,params_page,2);
            }
            else if(c_type == 2){
                this.onModalInitRole(params_page,2);
            }
            else if(c_type == 3){
                this.onModalInitAuthSystem(params_page,2);
            }
        },
        resetSource(){
            // //清空数据
            // this.originData = [];
            // this.savedPages = [];
            // this.selectedRowKeys = [];
        },
        getSelectedKey(targetArray,tkey){
            this.originData = targetArray;
            let result = [];
            targetArray.forEach(element => {
                result.push(element[tkey]) 
            });
            return result;
        },
        onModalInit(usercode,pageNum,flag,selectedData){
            let selectedKeys = undefined;
            if(selectedData){
                selectedKeys = this.getSelectedKey(selectedData,'organizationcode')
            }
            if(flag == 1){
                this.resetSource()
            }
            this.usercode = usercode;
            let that = this;
            that.type = 1;
            that.code_title = that.columns[0].title = '组织编码';
            that.name_title = that.columns[1].title = '组织名称';
            let c_params = {
                usercode:usercode,
                pageSize:that.pagination.pageSize,
                page:pageNum
            }
            if(that.searchKey == 'zname'){
                c_params.organizationname = that.searchVal
            }
            else{
                c_params.organizationcode = that.searchVal
            }
            that.$store.dispatch({
                type: "usercenter/selectOrgList",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                let result = res.data.data;
                if(result.list){
                    that.originData = that.originData.concat(result.list)
                }
  
                that.handle_list_data(result.list,that)
                if(selectedKeys){
                    that.selectedRowKeys = selectedKeys;
                }
                that.pagination.total = result.totalRecords;
                that.pagination.pageSize = result.pageSize;
                that.pagination.current = result.page;
                that.title = '选择所属组织';
            })
            that.visible = true;
        },
        onModalInitRole(pageNum,flag,selectedData){
            let selectedKeys = undefined;
            if(selectedData){
                selectedKeys = this.getSelectedKey(selectedData,'code')
            }
            if(flag == 1){
                this.resetSource()
            }
            let that = this;
            that.type = 2;
            that.code_title = that.columns[0].title = '角色编码';
            that.name_title = that.columns[1].title = '角色名称';
            let c_params = {
                pageSize:that.pagination.pageSize,
                page:pageNum
            }
            if(that.searchKey == 'zname'){
                c_params.name = that.searchVal
            }
            else{
                c_params.code = that.searchVal
            }
            that.$store.dispatch({
                type: "usercenter/selectRoleList",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                let result = res.data.data;
                if(result.list){
                    that.originData = that.originData.concat(result.list)
                }
                that.handle_list_data(result.list,that)
                if(selectedKeys){
                    that.selectedRowKeys = selectedKeys;
                }
                that.pagination.total = result.totalRecords;
                that.pagination.pageSize = result.pageSize;
                that.pagination.current = result.page;
                that.title = '选择角色';
            })
            that.visible = true;
        },
        onModalInitAuthSystem(pageNum,flag,selectedData){
            let selectedKeys = undefined;
            if(selectedData){
                selectedKeys = this.getSelectedKey(selectedData,'syscode')
            }
            if(flag == 1){
                this.resetSource()
            }
            let that = this;
            that.type = 3;
            that.code_title = that.columns[0].title = '系统编码';
            that.name_title = that.columns[1].title = '系统名称';
            let c_params = {
                pageSize:that.pagination.pageSize,
                page:pageNum
            }
            if(that.searchKey == 'zname'){
                c_params.sysname = that.searchVal
            }
            else{
                c_params.syscode = that.searchVal
            }
            that.$store.dispatch({
                type: "usercenter/selectSystemList",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                let result = res.data.data;

                if(result.list){
                    that.originData = that.originData.concat(result.list)
                }
                that.handle_list_data(result.list,that)
                if(selectedKeys){
                    that.selectedRowKeys = selectedKeys;
                }
                that.pagination.total = result.totalRecords;
                that.pagination.pageSize = result.pageSize;
                that.pagination.current = result.page;
                that.title = '选择所属系统';
            })
            that.visible = true;
        },
        handle_list_data(resource,that){
            that.list = [];
            if(!resource){
                return
            }
            for (let i = 0; i < resource.length; i++) {
                const element = resource[i];
                if(that.type == 1){
                    that.list.push({s_code:element.organizationcode,s_name:element.organizationname});
                }
                else if(that.type == 2){
                    that.list.push({s_code:element.code,s_name:element.name});
                }
                else if(that.type == 3){
                    that.list.push({s_code:element.syscode,s_name:element.sysname});
                }
            }  
        },
        onSearchChange(value){
            this.searchKey = value;
        },
        onSearch(value){
            this.searchVal = value;
            let c_type = this.type;

            if(c_type == 1){
                this.onModalInit(this.usercode,1,2);
            }
            else if(c_type == 2){
                this.onModalInitRole(1,2);
            }
            else if(c_type == 3){
                this.onModalInitAuthSystem(1,2);
            }
            
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleOk(){
            let c_type = this.type;
            let current_keys = this.selectedRowKeys;
            let result = [];

            for (let index = 0; index < current_keys.length; index++) {
                const element = current_keys[index];
                let c_item = this.originData.filter(function(n){
                    if(c_type == 1){
                        return element == n.organizationcode
                    }
                    else if(c_type == 2){
                        return element == n.code
                    }
                    else if(c_type == 3){
                        return element == n.syscode
                    }
                });
                if(c_item.length == 0){
                    result = undefined
                    console.log("未找到对应数据")
                    break;
                }
                result.push(c_item[0])
            }

            this.$emit('onModalHide',result,c_type);
            this.visible = false;
        },
        handleCancel(e) {
            e.preventDefault()
            this.$emit('onModalHide');
            this.visible = false;
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    mounted() {

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
